import script from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=2a59a224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a59a224"]])

export default __exports__